// Recovered compiled webpack factory 85396. Edit this function expression; run npm run build.
(e, t, a) => {
  "use strict";
  a.d(t, { AT: () => l, MS: () => c, kq: () => d });
  let r = {
      utmSource: "attr_src",
      utmMedium: "attr_med",
      utmCampaign: "attr_cmp",
      utmTerm: "attr_trm",
      utmContent: "attr_cnt",
      referrer: "attr_ref",
      landingPage: "attr_lnd",
    },
    n = ["ultramock.io", "www.ultramock.io", "beta.ultramock.io", "localhost"];
  function i(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 256;
    if (!e) return null;
    let a = e.trim();
    return a ? (a.length > t ? a.slice(0, t) : a) : null;
  }
  let s = null,
    o = !1;
  function l() {
    return o
      ? s
      : ((o = !0),
        (s = (function (e) {
          let t = i(e.searchParams.get("utm_source")),
            a = i(e.searchParams.get("utm_medium")),
            r = i(e.searchParams.get("utm_campaign")),
            s = i(e.searchParams.get("utm_term")),
            o = i(e.searchParams.get("utm_content")),
            l = i(
              (function (e) {
                if (!e) return null;
                try {
                  var t;
                  let a = new URL(e);
                  if (((t = a.hostname), n.includes(t) || t.endsWith(".vercel.app"))) return null;
                  return a.origin;
                } catch {
                  return null;
                }
              })(e.referrer),
            );
          return t || a || r || s || o || l
            ? {
                utmSource: t,
                utmMedium: a,
                utmCampaign: r,
                utmTerm: s,
                utmContent: o,
                referrer: l,
                landingPage: (function (e) {
                  let t = i(e, 128);
                  return !t || !t.startsWith("/") || t.startsWith("//") ? null : t;
                })(e.pathname),
                capturedAt: new Date().toISOString(),
              }
            : null;
        })({
          searchParams: new URLSearchParams(window.location.search),
          referrer: document.referrer || null,
          pathname: window.location.pathname,
        })));
  }
  function c() {
    return l();
  }
  function d() {
    let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "/sign-in",
      t = (function (e) {
        let t = new URLSearchParams();
        if (!e) return t;
        for (let [a, n] of [
          [r.utmSource, e.utmSource],
          [r.utmMedium, e.utmMedium],
          [r.utmCampaign, e.utmCampaign],
          [r.utmTerm, e.utmTerm],
          [r.utmContent, e.utmContent],
          [r.referrer, e.referrer],
          [r.landingPage, e.landingPage],
        ])
          n && t.set(a, n);
        return t;
      })(c()).toString();
    return t ? `${e}${e.includes("?") ? "&" : "?"}${t}` : e;
  }
}
